import React from "react"
import { FlatList } from "react-native"
import { ProductCategoryCardView } from "./ProductCategoryCardView"

export const ProductCategoriesListView = (props) => {
    let numColumns = 3
    let categoryList = props.categoryList
    let action = props.action
    return <FlatList data={categoryList}
        numColumns={numColumns}
        keyExtractor={(item, index) => "category_view_" + item.cid + '_' + index}
        renderItem={({ item, index }) => <ProductCategoryCardView index={index}
            numColumns={numColumns} iconSize={props.iconSize}
            action={action} category={{ ...item, index: index }} />}
        snapToAlignment="start" />
}